import React, { useEffect, useState } from 'react';
import styled from 'styled-components/macro';
import SectionContainer from '../SectionContainer';
import SectionTitle from '../SectionTitle';
import SectionText from '../SectionText';
import ClientToolsTable from './ClientToolsTable';
import { device } from '../../../../style/Sizes';
import { TasklyText } from './AllSectionTexts';
import ScrollToTop from '../../../../hoc/ScrollToTop';
import Footer from '../../../Footer/Footer';

const Container = styled.div`
  width: 100%;
  height: auto;
  /* background: red; */
  text-align: center;
`;

const FirstSectionContainer = styled.div`
  position: relative;
  margin: 150px auto 72px auto;
  max-width: 1000px;
  padding-bottom: 0;
  background-color: #f5f5f5;
  /* background-color: #e6e9ea; */
  /* background-color: #C0C8CB; */
  /* background: gainsboro; */

  @media ${device.maxTablet} {
    padding-bottom: 32px;
  }
`;

const TitleContainer = styled.div`
  position: relative;
  float: left;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -47%);
  z-index: 2;
`;

const Title = styled.div`
  font-family: miller-display, serif;
  font-weight: 600;
  font-style: normal;
  font-size: 79px;
  /* letter-spacing: -0.5px; */
`;

const SubTitle = styled.div`
  font-family: miller-headline, serif;
  font-weight: 700;
  font-style: italic;
  font-size: 19px;
  letter-spacing: 0.8px;
`;

// const Role = 'My Role';

const TasklyContainer = () => {
  const [desktop, setDesktop] = useState();
  // const [clHeight, setClHeight] = useState();
  const [clWidth, setClWidth] = useState();

  const checkDesktop = () => {
    window.matchMedia('(min-width: 768px)').matches
      ? setDesktop(true)
      : setDesktop(false);
    // setClHeight(document.documentElement.clientHeight);
    setClWidth(document.documentElement.clientWidth);
  };

  useEffect(() => {
    checkDesktop();
  });

  useEffect(() => {
    window.addEventListener('resize', checkDesktop);
    return () => {
      window.removeEventListener('resize', checkDesktop);
    };
  });

  return (
    <ScrollToTop>
      <Container>
        <FirstSectionContainer clWidth={clWidth}>
          <TitleContainer>
            <Title>taskly</Title>
            <SubTitle>The smart and simple family organizer</SubTitle>
          </TitleContainer>
          <SectionContainer
            noTransition
            containerMarginBottom={'100px'}
            src={require('../../../../assets/images/TasklyMockUpTop.png')}
            alt="MockupTop"
            imgContainerHeight={'94vw'}
            imgContainerMaxHeight={'942px'}
            imgContainerMinHeight={''}
            imgHeight={'80%'}
            imgMarginTop={clWidth < 515 ? '80px' : '16%'}
          />
          <ClientToolsTable desktop={desktop} />
        </FirstSectionContainer>
        <SectionTitle
          sectionTitle={TasklyText.AboutTaskly}
          titleMarginBottom={'default'}
        />
        <SectionText
          sectionText={TasklyText.AboutTasklyText}
          textMarginBottom={'default'}
        />
        <SectionTitle
          sectionTitle={TasklyText.TheChallenge}
          titleMarginBottom={'default'}
        />
        <SectionText
          sectionText={TasklyText.TheChallengeText}
          textMarginBottom={'default'}
        />
        <SectionTitle
          sectionTitle={TasklyText.MyRole}
          titleMarginBottom={'default'}
        />
        <SectionText
          sectionText={TasklyText.MyRoleText}
          textMarginBottom={'160px'}
        />
        <SectionContainer
          containerMarginBottom={'default'}
          sectionTitle={TasklyText.DesignProcess}
          titleMarginBottom={'8px'}
          sectionSubTitle={TasklyText.DesignProcessSub}
          subTitleMarginBottom={'default'}
          sectionText={TasklyText.DesignProcessText}
          textMarginBottom={'default'}
          src={require('../../../../assets/images/TasklyDoubleDiamond.png')}
          alt="DesignProcess"
          imgContainerHeight={'80vw'}
          imgContainerMaxHeight={'700px'}
          imgHeight={'70%'}
          imgMarginTop={'auto'}
        />
        <SectionContainer
          containerMarginBottom={'default'}
          sectionTitle={TasklyText.Survey}
          titleMarginBottom={'default'}
          sectionText={TasklyText.SurveyText}
          textMarginBottom={'default'}
          src={require('../../../../assets/images/TasklySurvey.png')}
          alt="Survey"
          imgContainerHeight={'80vw'}
          imgContainerMaxHeight={'700px'}
          imgHeight={'90%'}
          imgMarginTop={'auto'}
        />
        <SectionContainer
          containerMarginBottom={'default'}
          sectionTitle={TasklyText.Interviews}
          titleMarginBottom={'default'}
          sectionText={TasklyText.InterviewText}
          textMarginBottom={'default'}
          // src={require('../../../../assets/images/TaskModel.png')}
          // alt="MockupTop"
          imgContainerHeight={'0'}
          // imgContainerMaxHeight={'700px'}
          // imgHeight={'80%'}
          // imgMarginTop={'20%'}
        />
        <SectionContainer
          containerMarginBottom={'default'}
          sectionTitle={TasklyText.UserPersonas}
          titleMarginBottom={'default'}
          sectionText={TasklyText.UserPersonasText}
          textMarginBottom={'default'}
          src={require('../../../../assets/images/TasklyPersonas.png')}
          alt="Personas"
          imgContainerHeight={'80vw'}
          imgContainerMaxHeight={'700px'}
          imgHeight={'90%'}
          imgMarginTop={'auto'}
        />
        <SectionContainer
          containerMarginBottom={'default'}
          sectionTitle={TasklyText.TaskModel}
          titleMarginBottom={'default'}
          sectionText={TasklyText.TaskModelText}
          textMarginBottom={'default'}
          src={require('../../../../assets/images/TasklyTaskModel.png')}
          alt="TaskModel"
          imgContainerHeight={'80vw'}
          imgContainerMaxHeight={'700px'}
          imgHeight={'80%'}
          imgMarginTop={'auto'}
        />
        <SectionContainer
          containerMarginBottom={'default'}
          sectionTitle={TasklyText.CustomerExperienceMap}
          titleMarginBottom={'default'}
          sectionText={TasklyText.CustomerExperienceMapText}
          textMarginBottom={'default'}
          src={require('../../../../assets/images/TasklyCustomerExperienceMap.png')}
          alt="CustomerExperienceMap"
          imgContainerHeight={'80vw'}
          imgContainerMaxHeight={'700px'}
          imgHeight={'80%'}
          imgMarginTop={'auto'}
        />
        <SectionContainer
          containerMarginBottom={'default'}
          sectionTitle={TasklyText.OpenCardSort}
          titleMarginBottom={'default'}
          sectionText={TasklyText.OpenCardSortText}
          textMarginBottom={'default'}
          src={require('../../../../assets/images/TasklyCardSort.png')}
          alt="CardSort"
          imgContainerHeight={'80vw'}
          imgContainerMaxHeight={'700px'}
          imgHeight={'90%'}
          imgMarginTop={'auto'}
        />
        <SectionContainer
          containerMarginBottom={'default'}
          sectionTitle={TasklyText.SiteMap}
          titleMarginBottom={'default'}
          sectionText={TasklyText.SiteMapText}
          textMarginBottom={'default'}
          src={require('../../../../assets/images/TasklySiteMap.png')}
          alt="SiteMap"
          imgContainerHeight={'80vw'}
          imgContainerMaxHeight={'700px'}
          imgHeight={'90%'}
          imgMarginTop={'auto'}
        />
        <SectionContainer
          containerMarginBottom={'default'}
          sectionTitle={TasklyText.PaperPrototypes}
          titleMarginBottom={'default'}
          sectionText={TasklyText.PaperPrototypesText}
          textMarginBottom={'default'}
          src={require('../../../../assets/images/TasklyPaperPrototypes.png')}
          alt="MockupTop"
          imgContainerHeight={'80vw'}
          imgContainerMaxHeight={'1000px'}
          imgHeight={'90%'}
          imgMarginTop={'auto'}
        />
        <SectionContainer
          containerMarginBottom={'default'}
          sectionTitle={TasklyText.Wireframes}
          titleMarginBottom={'default'}
          sectionText={TasklyText.WireframesText}
          textMarginBottom={'default'}
          src={require('../../../../assets/images/TasklyWireframes.png')}
          alt="Wireframes"
          imgContainerHeight={'80vw'}
          imgContainerMaxHeight={'1000px'}
          imgHeight={'90%'}
          imgMarginTop={'auto'}
        />
        <SectionContainer
          containerMarginBottom={'default'}
          sectionTitle={TasklyText.UserFlow}
          titleMarginBottom={'default'}
          sectionText={TasklyText.UserFlowText}
          textMarginBottom={'default'}
          src={require('../../../../assets/images/TasklyUserFlow.png')}
          alt="UserFlow"
          imgContainerHeight={'90vw'}
          imgContainerMaxHeight={'900px'}
          imgHeight={'120%'}
          imgMarginTop={'-10%'}
          fullWidth
        />
        <SectionContainer
          containerMarginBottom={'default'}
          sectionTitle={TasklyText.StyleTile}
          titleMarginBottom={'default'}
          sectionText={TasklyText.StyleTileText}
          textMarginBottom={'default'}
          src={require('../../../../assets/images/TasklyStyleTile.png')}
          alt="StyleTile"
          imgContainerHeight={'90vw'}
          imgContainerMaxHeight={'900px'}
          imgHeight={'120%'}
          imgMarginTop={'auto'}
          fullWidth
        />
        <SectionContainer
          containerMarginBottom={'default'}
          sectionTitle={TasklyText.VisualDesign}
          titleMarginBottom={'default'}
          // sectionText={TasklyText.VisualDesignText}
          textMarginBottom={'default'}
          src={require('../../../../assets/images/TasklyVisualDesign.png')}
          alt="VisualDesign"
          imgContainerHeight={'190vw'}
          imgContainerMaxHeight={'2000px'}
          imgHeight={'120%'}
          imgMarginTop={'auto'}
          fullWidth
        />
      </Container>
      <Footer />
    </ScrollToTop>
  );
};

export default TasklyContainer;
